// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__25f9G","productName":"Table_productName__3nVvc"};